// Phone validation utility functions for Rever
import i18next from '../i18next';

export const getCountryFlag = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.length < 2) return '';
  
  const cleanPhone = phoneNumber.replace(/\s+/g, '').replace(/[^0-9+]/g, '');
  if (!cleanPhone.startsWith('+')) return '';
  
  const number = cleanPhone.substring(1);
  
  // Country code to flag emoji mapping
  if (number.startsWith('998')) return '🇺🇿'; // Uzbekistan
  if (number.startsWith('7')) return '🇷🇺'; // Russia/Kazakhstan
  if (number.startsWith('1')) return '🇺🇸'; // USA/Canada
  if (number.startsWith('90')) return '🇹🇷'; // Turkey
  if (number.startsWith('44')) return '🇬🇧'; // UK
  if (number.startsWith('49')) return '🇩🇪'; // Germany
  if (number.startsWith('33')) return '🇫🇷'; // France
  if (number.startsWith('86')) return '🇨🇳'; // China
  if (number.startsWith('971')) return '🇦🇪'; // UAE
  if (number.startsWith('966')) return '🇸🇦'; // Saudi Arabia
  if (number.startsWith('91')) return '🇮🇳'; // India
  if (number.startsWith('81')) return '🇯🇵'; // Japan
  
  return '🌍'; // Default world emoji for unknown countries
};

export const validatePhone = (value, t) => {
  if (!value || value.trim() === '' || value === '+') {
    return t('validation.phoneRequired');
  }
  
  const cleanPhone = value.replace(/\s+/g, '').replace(/[^0-9+]/g, '');
  
  if (!cleanPhone.startsWith('+')) {
    return t('validation.phoneInvalid');
  }
  
  const phoneWithoutPlus = cleanPhone.substring(1);
  
  if (!/^\d+$/.test(phoneWithoutPlus)) {
    return t('validation.phoneOnlyNumbers');
  }
  
  // Country-specific validation
  if (phoneWithoutPlus.startsWith('998')) {
    if (phoneWithoutPlus.length !== 12) {
      return t('validation.phoneUzbekistan');
    }
    return '';
  }
  
  if (phoneWithoutPlus.startsWith('7')) {
    if (phoneWithoutPlus.length !== 11) {
      return t('validation.phoneRussia');
    }
    return '';
  }
  
  if (phoneWithoutPlus.startsWith('1')) {
    if (phoneWithoutPlus.length !== 11) {
      return t('validation.phoneUSA');
    }
    return '';
  }
  
  if (phoneWithoutPlus.startsWith('90')) {
    if (phoneWithoutPlus.length !== 12) {
      return t('validation.phoneTurkey');
    }
    return '';
  }
  
  if (phoneWithoutPlus.startsWith('44')) {
    if (phoneWithoutPlus.length !== 12) {
      return t('validation.phoneUK');
    }
    return '';
  }
  
  // General validation for other countries
  if (phoneWithoutPlus.length < 10) {
    return t('validation.phoneTooShort');
  }
  
  if (phoneWithoutPlus.length > 15) {
    return t('validation.phoneTooLong');
  }
  
  return '';
};

export const handlePhoneChangeHelper = (value) => {
  let processedValue = value;
  
  // Auto-add + if not present and user starts typing
  if (processedValue.length > 0 && !processedValue.startsWith('+')) {
    processedValue = '+' + processedValue;
  }
  
  // Ensure + stays at the beginning
  if (processedValue.length > 0 && !processedValue.startsWith('+')) {
    processedValue = '+' + processedValue.replace(/\+/g, '');
  }
  
  return processedValue;
};
